import { Button, Tooltip } from "@mui/material";
import { translate } from "../../../utils/translate";
import css from "../../../css/modules/toolbar.module.scss";
import { ViewPresetSelect } from "../../../components/Toolbar/ViewPresetSelect";
import { useCallback } from "react";
import { usePageApi } from "./PageApi";
import { ToggleVisibilityButtons } from "../../../components/Toolbar/ToggleVisibilityButtons";
import { useSelector } from "react-redux";
import { multiViewSettingSelector } from "../../../redux/setting";
import { Features } from "../../../components/Toolbar/Features";
import { SaveSettings } from "../../../components/Toolbar/SaveSettings";
import { groupNames } from "../../Settings/components/From/utils";
import { ExportButton } from "../../Project/components/ExportButton";

export function Toolbar({ overview }) {
  const { api } = usePageApi();
  const onExpand = useCallback(() => api.gantt.expandAll(), [api]);
  const onNext = useCallback(async () => {
    const x = api.activeElement?.timeAxisSubGrid?.scrollable?.scrollWidth;
    if (x) {
      await api.activeElement?.shiftNext();
      await api.activeElement?.scrollTo(x);
    }
  }, [api]);
  const onPrev = useCallback(async () => {
    await api.activeElement?.shiftPrevious();
    await api.activeElement?.scrollTo(0);
  }, [api]);
  const onCollapse = useCallback(() => api.gantt.collapseAll(), [api]);
  const onZoomIn = useCallback(() => api.activeElement.zoomIn(), [api]);
  const onZoomOut = useCallback(() => api.activeElement.zoomOut(), [api]);
  const onZoomToFit = useCallback(() => {
    try {
      api.activeElement.zoomToFit({
        leftMargin: 50,
        rightMargin: 50,
      });
    } catch (err) {
      console.log("zoomToFit is not working on ", api.activeElement?.constructor?.name);
    }
  }, [api]);
  const onPresetClick = useCallback(
    (id) => {
      if (api.activeElement) {
        api.activeElement.viewPreset = id;
      }
    },
    [api]
  );
  const configs = useSelector(multiViewSettingSelector);

  return (
    <div className={css.btnContainer}>
      <ToggleVisibilityButtons
        api={api}
        hideGantt
        hideScheduler
        overview={overview}
        configs={configs}
      />
      <Tooltip title={translate("Expand all")} data-testid="tb_projectoverview_expand_all">
        <Button onClick={onExpand} size="small" className={css.iconBtn}>
          <span className="ico icon-rank2 deg-180" />
        </Button>
      </Tooltip>
      <Tooltip title={translate("Collapse all")}>
        <Button onClick={onCollapse} size="small" className={css.iconBtn}>
          <span className="ico icon-rank2" />
        </Button>
      </Tooltip>
      <ViewPresetSelect onChange={onPresetClick} api={api} />
      <Tooltip title={translate("Zoom in")}>
        <Button onClick={onZoomIn} size="small" className={css.iconBtn}>
          <span className="ico icon-zoom-in" />
        </Button>
      </Tooltip>
      <Tooltip title={translate("Zoom out")}>
        <Button onClick={onZoomOut} size="small" className={css.iconBtn}>
          <span className="ico icon-zoom-out" />
        </Button>
      </Tooltip>
      <Tooltip title={translate("Zoom to fit")} data-testid="tb_projectoverview_zoom_to_fit">
        <Button onClick={onZoomToFit} size="small" className={css.iconBtn}>
          <span className="ico icon-contract" />
        </Button>
      </Tooltip>
      <Tooltip title={translate("Previous time span")}>
        <Button onClick={onPrev} size="small" className={css.iconBtn}>
          <span className="ico icon-chevron-left" />
        </Button>
      </Tooltip>
      <Tooltip title={translate("Next time span")}>
        <Button onClick={onNext} size="small" className={css.iconBtn}>
          <span className="ico icon-chevron-right" />
        </Button>
      </Tooltip>
      <Features api={api} />
      <ExportButton overview={overview} api={api} allowMSPExport={false} />
      <SaveSettings api={api} configs={configs} groupKey={groupNames.MULTI_PROJECT_GANTT_CONFIG} />
    </div>
  );
}
